import { Button, Icon } from "@src/components/atoms";
import { useEffect, useState } from "react";

export const IndustryContentEditor = ({
  industry,
  industryStrings,
  onChange,
}) => {
  const [values, setValues] = useState(industryStrings);
  const [showMessage, setShowMessage] = useState(false);

  const required =
    industry === "global" &&
    (industryStrings.length == 1 ||
      Object.values(industryStrings).every((v) => !v.length));

  useEffect(() => {
    setValues(industryStrings);
  }, [industryStrings]);

  const handleUpdate = (idx, val) => {
    const updated = [...values];
    updated[idx] = val;
    setValues(updated);
    onChange(updated);
  };

  const handleAdd = () => {
    const updated = [...values, ""];
    setValues(updated);
    onChange(updated);
  };

  const handleRemove = (idx) => {
    const canDelete = industry !== "global" || values.length > 1;
    const updated = values.filter((_, i) => i !== idx);
    if (canDelete) {
      setValues(updated);
      onChange(updated);
    } else {
      setShowMessage(true);
    }
  };

  return (
    <div className="bg-primary-100 rounded-xl mx-2 my-4 px-4 py-6">
      <h3 className="font-bold mb-2">{industry.toUpperCase()}</h3>
      {industry === "global" && showMessage && (
        <p className="text-orange-500">
          It is not possible to remove all global strings, one must remain.
        </p>
      )}
      {values?.map((val, idx) => (
        <div key={idx} className="flex items-center mb-2">
          <textarea
            className={`my-2 rounded-md flex-grow-1 pl-3 pr-10 py-2 text-base leading-6 border
            focus:outline-none sm:text-sm sm:leading-5 ${
              required && !val.length
                ? "bg-orange-100 border-orange-500"
                : "bg-white border-gray-300 focus:border-primary-500"
            }`}
            value={val}
            onChange={(e) => handleUpdate(idx, e.target.value)}
          />
          <div
            onClick={() => handleRemove(idx)}
            className="ml-2 cursor-pointer hover:scale-102"
            title="Remove string"
          >
            <Icon
              name="close"
              textColor="red"
              backgroundColor="transparent"
              title="Remove"
            ></Icon>
          </div>
        </div>
      ))}
      <div className="flex flex-row">
        <Button
          onClick={handleAdd}
          icon="plus"
          block={true}
          className="rounded-2xl"
          padding={false}
        >
          Add
        </Button>
      </div>
    </div>
  );
};
